import { useSelectedCollectionAssets } from '@features/Collection/hooks';
import { TableCard } from '@features/tableEngine/components';

import { useClipColumns } from '@features/Clip/hooks/useClipColumns';
import { useTranslation } from 'react-i18next';
import { Clip } from '@features/Clip';

const PAGE_SIZES = [...Array(5)].map((_, i) => (i + 1) * 10);

export const AvailableContentSection = () => {
    const { t } = useTranslation(['clipTable']);
    const columns = useClipColumns();

    const result = useSelectedCollectionAssets({
        pageSize: PAGE_SIZES[0],
        sorting: [{ id: 'title', desc: false }],
    });

    return (
        <TableCard<Clip>
            {...result}
            config={{
                title: t('title'),
                search: {
                    enabled: true,
                    placeholder: t('search.placeholder'),
                },
                selection: {
                    enabled: true,
                    displayKey: 'clipName',
                },
                pagination: { enabled: true, pageSizes: PAGE_SIZES },
                columns,
            }}
        />
    );
};
